import { render } from "./InstructorHome.vue?vue&type=template&id=7e1ab361&scoped=true"
import script from "./InstructorHome.vue?vue&type=script&lang=js"
export * from "./InstructorHome.vue?vue&type=script&lang=js"

import "./InstructorHome.vue?vue&type=style&index=0&id=7e1ab361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1ab361"]])

export default __exports__